var _circle, _circle2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 107,
    viewBox: "0 0 108 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 53.5,
    r: 48.5,
    fill: "#F1F2F9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 53.5,
    r: 51,
    stroke: "#F1F2F9",
    strokeOpacity: 0.2,
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7 43.9502C38.5104 46.8426 37.3279 50.3724 37.3333 54.0002C37.3333 63.2002 44.8 70.6668 54 70.6668C63.2 70.6668 70.6667 63.2002 70.6667 54.0002C70.6667 44.8002 63.2 37.3335 54 37.3335",
    stroke: "#5575F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M42.3333 54.0002C42.3333 60.4502 47.55 65.6668 54 65.6668C60.45 65.6668 65.6666 60.4502 65.6666 54.0002C65.6666 47.5502 60.45 42.3335 54 42.3335",
    stroke: "#5575F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M54 60.6668C57.6833 60.6668 60.6667 57.6835 60.6667 54.0002C60.6667 50.3168 57.6833 47.3335 54 47.3335",
    stroke: "#5575F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrial);
export default __webpack_public_path__ + "static/media/trial.3da907633adc1651a8d2931c13a07fa7.svg";
export { ForwardRef as ReactComponent };